const initialState = {
  hidden: true,
  cart: [],
  products: [
    {
      id: 1,
      color: "Burnt Orange",
      design: "Static Ant",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/burnt.png",
      price: 1.99
    },
    {
      id: 2,
      color: "Blue Steel",
      design: "Battle Ant",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/bluesteel.png",
      price: 29.99
    },
    {
      id: 3,
      color: "Gold",
      design: "Merch Dropper",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/gold.png",
      price: 1.99
    },
    {
      id: 4,
      color: "Oxblood",
      design: "Static Ant",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/oxblood.png",
      price: 29.99
    },
    {
      id: 5,
      color: "Heather Stone",
      design: "Battle Ant",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/heatherStone.jpg",
      price: 29.99
    },
    {
      id: 6,
      color: "Black",
      design: "Merch Dropper",
      url:
        "https://raw.githubusercontent.com/Jeris-Manning/FILES/master/shirtsSmall/black.png",
      price: 29.99
    }
  ]
};

export default initialState;
